import React from "react";

import classNames from "classnames";
import brand from "@utils/brand";
import { Container, Image } from "@atoms";
import { HeadingWIcon } from "@molecules";

const Hero = ({ backgroundImage, heading, copy, featuredAction, cards }) => {
  const { romero } = brand;
  return (
    <div className="relative z-0 bg-white pt-48 pb-6">
      <div
        className={classNames("absolute top-0 left-0 right-0 z-0", {
          "bg-brown": !romero,
          "bg-blue-dark": romero,
        })}
        style={{ height: "150%" }}
      >
        <div className="absolute top-0 left-0 right-0 z-10 h-48 rotate-180 transform bg-gradient-to-b from-transparent to-black opacity-50" />
        <div className="absolute bottom-0 left-0 right-0 z-10 h-48 bg-gradient-to-b from-transparent to-cream" />
        <div className="absolute inset-0 z-0 opacity-40">
          {backgroundImage && (
            <Image
              image={backgroundImage}
              ixParams={{ exp: "-7", con: 5 }}
              fill
            />
          )}
        </div>
      </div>
      <div className="relative z-10">
        <Container>
          <div className="mb-6 max-w-xl">
            <HeadingWIcon
              icon="sunrise"
              heading={heading}
              copy={copy}
              inverse
            />
          </div>
        </Container>
      </div>
    </div>
  );
};

Hero.defaultProps = {};

export default Hero;
